import React from 'react';
import { Formik } from 'formik';
import { Grid, Form, Button, Divider } from 'semantic-ui-react';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Column } from 'components/Layout';
import getErrors from 'shared/lib/geterrors';
import AgenziaKironService from 'shared/services/api/agenziakiron';
import GruppoAgenziaKironService from 'shared/services/api/agenziakiron/gruppo';
import ProfiloService from 'shared/services/api/collaboratore/profilo';

import { AsyncSelect } from '../../UI/AsyncSelect';
import { SingleSelect } from '../../UI/Select';
import { DatePicker } from '../../UI/DatePicker';

const DividerForm = () => <Column width={16}><Divider fitted style={{ marginLeft: -20, marginRight: -20 }} /></Column>;

export class ProfiloForm extends React.Component {
  state = {
    gruppi: [],
    labelProfilo: '',
  }

  componentDidMount() {
    this.init();
  }

  init = () => {
    this.setState({ labelProfilo: _.get(this.props, 'initialValues.tipoProfiloCollaboratore.label') },
    () => {
      if (this.props.initialValues && this.props.initialValues.agenziakiron && this.props.initialValues.agenziakiron.value) {
        this.populateGroups(this.props.initialValues.agenziakiron.value);
      }
    }
    );
  }

  populateGroups = (agenziaId) => {
    if (_.get(this.state, 'labelProfilo') === 'Senior manager') {
      GruppoAgenziaKironService.getGruppiWithoutSeniorOptions(agenziaId)
        .then((data) => this.setState({ gruppi: data }));
    } else {
      GruppoAgenziaKironService.getGruppiOptions(agenziaId)
      .then((data) => this.setState({ gruppi: data }));
    }
  }

  render() {
    const props = this.props;
    return (
      <Grid style={{ paddingBottom: 15 }}>
        <Column width={16}>
          <Formik
            initialValues={{
              uuid: props.initialValues ? props.initialValues.uuid : '',
              id: props.initialValues ? props.initialValues.id : '',
              tipoProfiloCollaboratore: (props.initialValues && props.initialValues.tipoProfiloCollaboratore) ? props.initialValues.tipoProfiloCollaboratore : '',
              dataInizioValidita: (props.initialValues && props.initialValues.dataInizioValidita) ? props.initialValues.dataInizioValidita : '',
              dataFineValidita: (props.initialValues && props.initialValues.dataFineValidita) ? props.initialValues.dataFineValidita : '',
              agenziakiron: (props.initialValues && props.initialValues.agenziakiron) ? props.initialValues.agenziakiron : '',
              responsabileArea: '',
              gruppo: (props.initialValues && props.initialValues.gruppo) ? props.initialValues.gruppo : '',
              gruppi: [],
              createdAt: props.initialValues && props.initialValues.createdAt ? props.initialValues.createdAt : '',
            }}
            validate={values => { // eslint-disable-line
              // same as above, but feel free to move this into a class method now.
              let errors = {}; // eslint-disable-line
            /* if (!values.email) {
                errors.email = 'Required';
              } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
              ) {
                errors.email = 'Invalid email address';
              }*/
              return errors;
            }}
            onSubmit={(
              values,
              { setSubmitting, setErrors /* setValues and other goodies */ } // eslint-disable-line
            ) => {
              setSubmitting(true);

              props.addAction(values).then( // As in prop catch error is handled and not thrown we have to verify status inside .then()
              (data) => {
                setSubmitting(false);
                if (data.status === 200 || data.status === 201 || !data.status) {
                  props.closeModal();
                } else {
                  const errorsObj = getErrors(data);
                  setSubmitting(false);
                  setErrors(errorsObj);
                }
              }
            );
              // props.closeModal();
            }}
            render={({
              values,
              errors,
              touched,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setFieldTouched,
              }) => (
                <Form autoComplete="off" onSubmit={handleSubmit} loading={isSubmitting}>
                  <Grid>
                    <Column width={16}>
                      <AsyncSelect
                        loadOptions={ProfiloService.getTipiOptions}
                        value={values.tipoProfiloCollaboratore}
                        onChange={(fieldName, data) => {
                          this.setState({
                            labelProfilo: data.label,
                          }, () => {
                            setFieldValue(fieldName, data);
                            setFieldValue('gruppo', '');
                            if (values.agenziakiron.value) {
                              this.populateGroups(values.agenziakiron.value);
                            }
                          });
                        }}
                        onBlur={setFieldTouched}
                        error={errors.tipoProfiloCollaboratore}
                        touched={touched.tipoProfiloCollaboratore}
                        name="tipoProfiloCollaboratore"
                        label="Tipo"
                      />
                    </Column>
                    <Column width={16}>
                      <DatePicker touched={touched} errors={errors} value={values.dataInizioValidita} onChange={setFieldValue} name="dataInizioValidita" label="Inizio validità" startDate={moment()} openDirection="up" />
                    </Column>
                    <Column width={16}>
                      <DatePicker touched={touched} errors={errors} value={values.dataFineValidita} onChange={setFieldValue} name="dataFineValidita" label="Fine validità" startDate={moment()} openDirection="up" />
                    </Column>
                    <Column width={16}>
                      <AsyncSelect
                        loadOptions={AgenziaKironService.getAgenzieOptions}
                        value={values.agenziakiron}
                        onChange={(name, value) => {
                          setFieldValue(name, value);
                          setFieldValue('gruppo', '');
                          this.populateGroups(value.value);
                        }}
                        onBlur={setFieldTouched}
                        error={errors.agenziakiron}
                        touched={touched.agenziakiron}
                        name="agenziakiron"
                        label="Agenzia Kiron"
                      />
                    </Column>
                    <Column width={16}>
                      <SingleSelect
                        options={this.state.gruppi}
                        value={values.gruppo}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        error={errors.gruppo}
                        touched={touched.gruppo}
                        name="gruppo"
                        label="Gruppo"
                      />
                    </Column>
                    <DividerForm />
                    <Column width={16} textAlign="center">
                      <Button disabled={isSubmitting} primary style={{ marginTop: 7 }}>
                        {props.initialValues && props.initialValues.id ? 'Modifica' : 'Aggiungi'}
                      </Button>
                    </Column>

                  </Grid>
                </Form>
              )}
          />
        </Column>
      </Grid>);
  }
}

export default ProfiloForm;

ProfiloForm.propTypes = {
  initialValues: PropTypes.object,
};




// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Collaboratore/profiloForm.js